// extracted by mini-css-extract-plugin
export default {"ace-c-contact-details-panel__contact-link":"contact-details-panel__contact-link---9483e467"};